module.exports = __webpack_public_path__ + "img/reporting.e5b2123e.png";